module.exports = __webpack_public_path__ + "img/LightboxPopUp.a81e7c65.png";